import { FC } from 'react';
import Box from 'yoda-ui/components/Box';

const FormLayoutMidPanel: FC = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      flex="grow"
      flexGrow={ 1 }
    >
      { children }
    </Box>
  );
};

export default FormLayoutMidPanel;
